import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import CheckCSName from "../CheckCSName";
import EmptyLine from "../EmptyLine";
import {useUser} from "../../../context/UserContext";
import ResultView from "../../../components/ResultView";
import ResultTable from "../../../components/table/ResultTable";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultBody from "../../../components/table/ResultBody";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import HecRasHelper from "../../../helpers/HecRasHelper";

export function B18({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.ST05.error_id: {
            return (
                <>
                    <ResultText>
                        {
                            row?.data?.map(r => {
                                return (
                                    <>
                                        The {r?.type} at RS {<CheckCSName csName={r?.cross_section} />} is missing Section {r?.sections.join(', ')}.
                                        <EmptyLine />
                                    </>
                                )
                            })
                        }
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Internal.ST10.error_id: {
            const mode = settings?.thresholds?.structure_distance_mode ?? 'auto'
            const minDist = settings?.thresholds?.structure_distance_min ?? 5
            const maxDist = settings?.thresholds?.structure_distance_max ?? 10
            return (
                <>
                    <ResultText>
                        {
                            mode === 'auto'
                                ? <>The bounding cross sections of the following structures are not within the auto-computed recommended distance from the US/DS face of the structure.</>
                                : <>The bounding cross sections of the following structures are not within the recommended distance ({minDist} - {maxDist} ft) from the US/DS face of the structure.</>
                        }
                    </ResultText>
                    <EmptyLine />
                    <ResultTable >
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(12), textAlign: 'left'}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'left'}}>Structure</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(14), textAlign: 'right'}}>Section 2 (DS)</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(14), textAlign: 'right'}}>Section 3 (US)</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(14), textAlign: 'center'}}>DS</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(14), textAlign: 'center'}}>US</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map((r, idx) => {
                                    const fmtRange = (mn, mx) => {
                                        const mnStr = mn === null || mn === undefined || isNaN(parseFloat(mn)) ? '-' : parseFloat(mn).toFixed(0)
                                        const mxStr = mx === null || mx === undefined || isNaN(parseFloat(mx)) ? '-' : parseFloat(mx).toFixed(0)
                                        if (mnStr === '-' && mxStr === '-') return '-'
                                        return `${mnStr} - ${mxStr}`
                                    }
                                    return (
                                        <ResultRow key={idx}>
                                            <ResultBodyCell style={{textAlign: 'left'}}>
                                                <CheckCSName csName={r?.cross_section} />
                                            </ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'left'}}>{r?.culvert_name || '-'}</ResultBodyCell>
                                            <ResultBodyCell style={{
                                                textAlign: 'right',
                                                color: r?.section_3_error ? 'red' : 'inherit'
                                            }}>
                                                {parseFloat(r?.section_3_dist)?.toFixed(0) || '-'}
                                            </ResultBodyCell>
                                            <ResultBodyCell style={{
                                                textAlign: 'right',
                                                color: r?.section_2_error ? 'red' : 'inherit'
                                            }}>
                                                {parseFloat(r?.section_2_dist)?.toFixed(0) || '-'}
                                            </ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'center'}}>
                                                {fmtRange(r?.ds_min, r?.ds_max)}
                                            </ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'center'}}>
                                                {fmtRange(r?.us_min, r?.us_max)}
                                            </ResultBodyCell>
                                        </ResultRow>
                                    )
                                })
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
    }
}